/**
 * Validates a value is an empty string
 * @param {any} value The value to validate.
 * @param {any} context Validation context
 * @param {number} context.min The minimum length of the string. If undefined, no minimum is enforced.
 * @param {number} context.max The maximum length of the string. If undefined, no maximum is enforced.
 * @return {Promise<string | null>} A promise that resolves to an error message, otherwise null.
 * @name stringLength
 * @memberof combinators
 */
async function validate(value, context) {
  // always pass on a null input
  if (value === undefined || value === null) {
    return Promise.resolve(null);
  }

  const { min, max } = context;
  if (min !== undefined && value.length < min) return Promise.resolve('value-too-short');
  if (max !== undefined && value.length > max) return Promise.resolve('value-too-long');
  return Promise.resolve(null);
}

module.exports = validate;